import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';

export interface DietaryRestriction {
  name: string;
  slug: string;
  field_name: string;
  remark: string;
  thumbnail: string;
  sort_order: number;
  id: number;
  selected: boolean;
}

export interface DietaryRestrictions {
  dietary_restrictions: DietaryRestriction[];
}

export async function getCustomerDietaryRestrictions() {
  return await send<DietaryRestrictions>({
    path: `/api/v2/customers/self/dietary_restrictions/`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
